import { createContext } from 'react';
import MenuManagementContextPropsType from './MenuManagementContextPropTypes';
import menuConfig from './menuConfig';

export default createContext<MenuManagementContextPropsType>(menuConfig);
